export default __webpack_public_path__ + "static/media/portada_Panel02_ENG.f61586e5.jpg";